import React from "react";
import { useMediaQuery } from "react-responsive";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";

export const SectionNine = () => {
    const isMobile = useMediaQuery({ maxWidth: 768 });


    const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

    return (
        <div className="section-9">
            <div className="container-fluid">

                <div className="flex align-items-center sect-5" style={{ justifyContent: isMobile ? "center" : "space-between", gap: "30px", margin: isMobile ? '0 0.2rem' : "0 5rem" }}  >
                    <div className="mid-text1" style={{ justifyContent: "left" }}>
                        <h1 style={{ justifyContent: "left", display: "flex" }}>Go Live in {`<`} 48 Hours </h1>
                        <p style={{ justifyContent: "left", display: "flex" }}>No dev time. No tech delays. Just plug and play.</p>
                    </div>

                    <div>
                        <button onClick={scrollToTop} className="cta3-Ind">
                            Book a Demo
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};
